import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useTrackmanParameterCategories = () => {
  const service = useServices().trackmanParameterCategoriesService;
  return useQuery({
    queryKey: ['adminTrackmanParameterCategories'],
    queryFn: service.getCategories,
    refetchOnWindowFocus: false,
  });
};
